module.exports = __webpack_public_path__ + "img/lb.bc14258.svg";